import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function ProgramCard({ program }) {
  return (
    <Link
      to="/classes"
      data-testid={`program-card-${program.slug}`}
      className={`group block card-hover border border-white/10 bg-[#0a0a0a] overflow-hidden flex flex-col ${program.span || ""}`}
    >
      {/* Image — sits above the text, no overlay */}
      <div className="relative w-full aspect-[16/10] overflow-hidden bg-black image-zoom">
        <img
          src={program.image}
          alt={program.title}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
        />
      </div>

      {/* Text block — below the image */}
      <div className="flex flex-col gap-3 p-6 lg:p-7 flex-1">
        <div className="flex items-center flex-wrap gap-2">
          <span className="text-[10px] uppercase tracking-[0.2em] px-2 py-1 border border-[#ffb700]/40 text-[#ffb700]">
            {program.level}
          </span>
          <span className="text-[10px] uppercase tracking-[0.2em] text-white/50">
            {program.age}
          </span>
        </div>
        <h3 className="font-display text-2xl lg:text-3xl text-white leading-tight">
          {program.title}
        </h3>
        <p className="text-sm text-white/70 leading-relaxed line-clamp-2">
          {program.description}
        </p>
        <div className="mt-auto pt-2 inline-flex items-center gap-2 text-xs uppercase tracking-wider text-[#ff4500] font-semibold">
          Explore <ArrowUpRight className="w-4 h-4 group-hover:rotate-45 transition-transform" />
        </div>
      </div>
    </Link>
  );
}
